
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[projectSlug]/comments",
      function () {
        return require("private-next-pages/[projectSlug]/comments/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[projectSlug]/comments"])
      });
    }
  